export enum VatRateGroup {
    exempt = 'exempt',
    general = 'general',
}
